import {Component, Input} from '@angular/core';
import {ResponseForm} from "../../../common/components/form/models/responsedemat.model";
import {ResponseStateInstruction} from "../../../common/components/form/models";

/**
 * Container d'affichage de la liste des avis pour cette demande
 */
@Component({
  selector: 'app-opinions-visualize',
  templateUrl: './opinions-visualize.component.html',
  styleUrls: ['./opinions-visualize.component.scss']
})
export class OpinionsVisualizeComponent {
  @Input() response: ResponseForm;
  @Input() lastInstructionState: ResponseStateInstruction;
  @Input() title = 'Vous pouvez voir l\'avis des autres personnes sollicitées';
  @Input() isExpanded: boolean = false;
}
